import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IManagementGroup } from '@interfaces/index';

@Component({
  selector: 'lib-management-group-modal',
  templateUrl: './management-group-modal.component.html',
  styleUrls: ['./management-group-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LibManagementGroupModalComponent {
  selectedGroup: IManagementGroup | null = null;

  constructor(
    public dialog_ref: MatDialogRef<LibManagementGroupModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { managementGroups: IManagementGroup[], selectedGroup: IManagementGroup | null }
  ) {
    this.selectedGroup = data.selectedGroup;
  }

  onSelect(): void {
    this.dialog_ref.close(this.selectedGroup);
  }

  onCancel(): void {
    this.dialog_ref.close(null);
  }
}
